import { imageUrl } from "./url";
const BASE_PATH = imageUrl
const ICONS = "assets/icons/"

export const USER_ICON = BASE_PATH + ICONS + "user.svg"
export const ATTCHED_ICON = BASE_PATH + ICONS + "Attachment.svg"
export const MONEYS_ICON = BASE_PATH + ICONS + "moneys.svg"